import api from './api';

// Get user profile
const getProfile = async () => {
  const response = await api.get('/users/me');
  return response.data;
};

// Update user profile
const updateProfile = async (userData) => {
  const response = await api.put('/users/me', userData);
  return response.data;
};

// Change password
const changePassword = async ({ oldPassword, newPassword }) => {
  const response = await api.patch('/users/me/password', { oldPassword, newPassword });
  return response.data; // { message }
};

// Upload avatar
const uploadAvatar = async (file) => {
  const form = new FormData();
  form.append('avatar', file);
  const response = await api.post('/users/me/avatar', form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data; // { avatarUrl }
};

const userService = {
  getProfile,
  updateProfile,
  changePassword,
  uploadAvatar,
};

export default userService;